import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_3 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_4 = { class: "flex border-b border-gray-200 mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "pt-4 border-t border-border"
}
const _hoisted_6 = {
  key: 0,
  class: "p-3 bg-green-100 text-green-700 rounded-md mb-3"
}
const _hoisted_7 = {
  key: 1,
  class: "p-3 bg-red-100 text-red-700 rounded-md mb-3"
}
const _hoisted_8 = { class: "flex justify-end space-x-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "mt-8 pt-6 border-t border-gray-200" }
const _hoisted_13 = {
  key: 0,
  class: "p-3 bg-blue-100 text-blue-700 rounded-md mb-3"
}
const _hoisted_14 = {
  key: 1,
  class: "p-3 bg-yellow-100 text-yellow-700 rounded-md mb-3"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "divide-y divide-gray-200" }
const _hoisted_17 = { class: "flex justify-between items-center" }
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = { class: "text-xs text-muted-foreground" }
const _hoisted_20 = { class: "flex space-x-2" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_24 = {
  key: 0,
  class: "divide-y divide-gray-200 mt-3"
}
const _hoisted_25 = { class: "flex justify-between items-center" }
const _hoisted_26 = { class: "font-medium" }
const _hoisted_27 = { class: "text-xs text-muted-foreground" }
const _hoisted_28 = { class: "flex space-x-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_34 = {
  key: 0,
  class: "pt-4 border-t border-border"
}
const _hoisted_35 = {
  key: 0,
  class: "p-3 bg-green-100 text-green-700 rounded-md mb-3"
}
const _hoisted_36 = {
  key: 1,
  class: "p-3 bg-red-100 text-red-700 rounded-md mb-3"
}
const _hoisted_37 = { class: "flex justify-end space-x-3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "mt-8 pt-6 border-t border-gray-200" }
const _hoisted_42 = {
  key: 0,
  class: "p-3 bg-blue-100 text-blue-700 rounded-md mb-3"
}
const _hoisted_43 = {
  key: 1,
  class: "p-3 bg-yellow-100 text-yellow-700 rounded-md mb-3"
}
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "divide-y divide-gray-200" }
const _hoisted_46 = { class: "flex justify-between items-center" }
const _hoisted_47 = { class: "font-medium" }
const _hoisted_48 = { class: "text-xs text-muted-foreground" }
const _hoisted_49 = { class: "flex space-x-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_53 = {
  key: 0,
  class: "divide-y divide-gray-200 mt-3"
}
const _hoisted_54 = { class: "flex justify-between items-center" }
const _hoisted_55 = { class: "font-medium" }
const _hoisted_56 = { class: "text-xs text-muted-foreground" }
const _hoisted_57 = { class: "flex space-x-2" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[32] || (_cache[32] = _createElementVNode("h1", { class: "text-2xl font-bold mb-6" }, "Document Upload", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Upload to Knowledgebase", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Upload documents to the Knowledgebase. These will be stored as OPERATIONS_MANUAL type documents. ", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.hasPcoRole)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeKnowledgebaseTab = 'pco')),
                class: _normalizeClass([
            'px-4 py-2 font-medium text-sm',
            _ctx.activeKnowledgebaseTab === 'pco'
              ? 'border-b-2 border-primary text-primary'
              : 'text-gray-500 hover:text-gray-700'
          ])
              }, " PCO ", 2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeKnowledgebaseTab = 'planners')),
            class: _normalizeClass([
            'px-4 py-2 font-medium text-sm',
            _ctx.activeKnowledgebaseTab === 'planners'
              ? 'border-b-2 border-primary text-primary'
              : 'text-gray-500 hover:text-gray-700'
          ])
          }, " Planners ", 2)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadToKnowledgebase && _ctx.uploadToKnowledgebase(...args)), ["prevent"])),
          class: "space-y-6 mb-6"
        }, [
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              for: "kb-file-upload",
              class: "block text-sm font-medium mb-1"
            }, "Select File", -1)),
            _createElementVNode("input", {
              type: "file",
              id: "kb-file-upload",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleKnowledgebaseFileChange && _ctx.handleKnowledgebaseFileChange(...args))),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            }, null, 32)
          ]),
          _createElementVNode("div", null, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              for: "kb-file-name",
              class: "block text-sm font-medium mb-1"
            }, "File Name (Optional)", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "kb-file-name",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.knowledgebaseFileName) = $event)),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "Custom file name (leave empty to use original filename)"
            }, null, 512), [
              [_vModelText, _ctx.knowledgebaseFileName]
            ])
          ]),
          (_ctx.knowledgebaseSuccessMessage || _ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.knowledgebaseSuccessMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.knowledgebaseSuccessMessage), 1))
                  : _createCommentVNode("", true),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error.message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "px-4 py-2 border border-input rounded-md hover:bg-accent transition-colors",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetKnowledgebaseForm && _ctx.resetKnowledgebaseForm(...args)))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "submit",
              class: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors",
              disabled: _ctx.loading || !_ctx.knowledgebaseSelectedFile
            }, [
              (_ctx.loading && _ctx.activeUploadType === 'knowledgebase')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Uploading..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "Upload to Knowledgebase"))
            ], 8, _hoisted_9)
          ])
        ], 32),
        _createElementVNode("div", _hoisted_12, [
          _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-lg font-medium mb-4" }, "Knowledgebase Files", -1)),
          (_ctx.loadingKnowledgebaseFiles)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Loading files... "))
            : (_ctx.filteredKnowledgebaseFiles.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No files have been uploaded to Knowledgebase yet. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredKnowledgebaseFiles.slice(0, 3), (file) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: file.name,
                        class: "py-3"
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(file.name), 1),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.formatFileSize(file.metadata?.size)) + " • " + _toDisplayString(_ctx.formatDate(file.created_at)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.downloadFileByName(file.name, _ctx.KNOWLEDGEBASE_BUCKET)),
                              class: "px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600",
                              title: "Download file"
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                })
                              ], -1)
                            ]), 8, _hoisted_21),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.confirmDelete(file.name, _ctx.KNOWLEDGEBASE_BUCKET)),
                              class: "px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600",
                              title: "Delete file"
                            }, _cache[17] || (_cache[17] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                })
                              ], -1)
                            ]), 8, _hoisted_22)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.filteredKnowledgebaseFiles.length > 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_ctx.showAllKnowledgebaseFiles)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredKnowledgebaseFiles.slice(3), (file) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: file.name,
                                  class: "py-3"
                                }, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("p", _hoisted_26, _toDisplayString(file.name), 1),
                                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.formatFileSize(file.metadata?.size)) + " • " + _toDisplayString(_ctx.formatDate(file.created_at)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.downloadFileByName(file.name, _ctx.KNOWLEDGEBASE_BUCKET)),
                                        class: "px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600",
                                        title: "Download file"
                                      }, _cache[18] || (_cache[18] = [
                                        _createElementVNode("svg", {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          class: "h-4 w-4",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_29),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.confirmDelete(file.name, _ctx.KNOWLEDGEBASE_BUCKET)),
                                        class: "px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600",
                                        title: "Delete file"
                                      }, _cache[19] || (_cache[19] = [
                                        _createElementVNode("svg", {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          class: "h-4 w-4",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_30)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAllKnowledgebaseFiles = !_ctx.showAllKnowledgebaseFiles)),
                          class: "w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors flex items-center justify-center"
                        }, [
                          (!_ctx.showAllKnowledgebaseFiles)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Show " + _toDisplayString(_ctx.filteredKnowledgebaseFiles.length - 3) + " more files", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_32, "Hide additional files"))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])),
          (_ctx.knowledgebaseFiles.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.refreshKnowledgebaseFiles && _ctx.refreshKnowledgebaseFiles(...args))),
                class: "mt-4 px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors w-full"
              }, " Refresh List "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Upload to Templates", -1)),
        _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Upload documents to the Templates storage. These will be stored as SALES_REPORT type documents. ", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadToTemplates && _ctx.uploadToTemplates(...args)), ["prevent"])),
          class: "space-y-6 mb-6"
        }, [
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("label", {
              for: "tpl-file-upload",
              class: "block text-sm font-medium mb-1"
            }, "Select File", -1)),
            _createElementVNode("input", {
              type: "file",
              id: "tpl-file-upload",
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleTemplatesFileChange && _ctx.handleTemplatesFileChange(...args))),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            }, null, 32)
          ]),
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", {
              for: "tpl-file-name",
              class: "block text-sm font-medium mb-1"
            }, "File Name (Optional)", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "tpl-file-name",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.templatesFileName) = $event)),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "Custom file name (leave empty to use original filename)"
            }, null, 512), [
              [_vModelText, _ctx.templatesFileName]
            ])
          ]),
          (_ctx.templatesSuccessMessage || _ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_ctx.templatesSuccessMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.templatesSuccessMessage), 1))
                  : _createCommentVNode("", true),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.error.message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              type: "button",
              class: "px-4 py-2 border border-input rounded-md hover:bg-accent transition-colors",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetTemplatesForm && _ctx.resetTemplatesForm(...args)))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "submit",
              class: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors",
              disabled: _ctx.loading || !_ctx.templatesSelectedFile
            }, [
              (_ctx.loading && _ctx.activeUploadType === 'templates')
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Uploading..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_40, "Upload to Templates"))
            ], 8, _hoisted_38)
          ])
        ], 32),
        _createElementVNode("div", _hoisted_41, [
          _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-lg font-medium mb-4" }, "Template Files", -1)),
          (_ctx.loadingTemplatesFiles)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Loading files... "))
            : (_ctx.templatesFiles.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, " No files have been uploaded to Templates yet. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("ul", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesFiles.slice(0, 3), (file) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: file.name,
                        class: "py-3"
                      }, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_47, _toDisplayString(file.name), 1),
                            _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.formatFileSize(file.metadata?.size)) + " • " + _toDisplayString(_ctx.formatDate(file.created_at)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.downloadFileByName(file.name, _ctx.TEMPLATES_BUCKET)),
                              class: "px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600",
                              title: "Download file"
                            }, _cache[25] || (_cache[25] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                })
                              ], -1)
                            ]), 8, _hoisted_50),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.confirmDelete(file.name, _ctx.TEMPLATES_BUCKET)),
                              class: "px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600",
                              title: "Delete file"
                            }, _cache[26] || (_cache[26] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                })
                              ], -1)
                            ]), 8, _hoisted_51)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.templatesFiles.length > 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        (_ctx.showAllTemplatesFiles)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_53, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesFiles.slice(3), (file) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: file.name,
                                  class: "py-3"
                                }, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("p", _hoisted_55, _toDisplayString(file.name), 1),
                                      _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.formatFileSize(file.metadata?.size)) + " • " + _toDisplayString(_ctx.formatDate(file.created_at)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.downloadFileByName(file.name, _ctx.TEMPLATES_BUCKET)),
                                        class: "px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600",
                                        title: "Download file"
                                      }, _cache[27] || (_cache[27] = [
                                        _createElementVNode("svg", {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          class: "h-4 w-4",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_58),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.confirmDelete(file.name, _ctx.TEMPLATES_BUCKET)),
                                        class: "px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600",
                                        title: "Delete file"
                                      }, _cache[28] || (_cache[28] = [
                                        _createElementVNode("svg", {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          class: "h-4 w-4",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_59)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAllTemplatesFiles = !_ctx.showAllTemplatesFiles)),
                          class: "w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors flex items-center justify-center"
                        }, [
                          (!_ctx.showAllTemplatesFiles)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Show " + _toDisplayString(_ctx.templatesFiles.length - 3) + " more files", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_61, "Hide additional files"))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])),
          (_ctx.templatesFiles.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.refreshTemplatesFiles && _ctx.refreshTemplatesFiles(...args))),
                class: "mt-4 px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors w-full"
              }, " Refresh List "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}